import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Input from 'Components/Input/Input';
import Icon from 'Components/Icon/Icon';
import Button from 'Components/Button/Button';
import useReducedErrors from 'Shared/hooks/useReducedErrors';
import TabNav from 'Components/TabNav/TabNav';

const LoginPageView = ({
  formikProps: {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    touched,
    values: { username, password },
  },
}) => {
  const history = useHistory();
  const IS_PATHNAME_INCLUDES_EMPLOYEE = history.location.pathname.includes('employee');
  const reducedErrors = useReducedErrors(errors);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [loginTab, setLoginTab] = useState(IS_PATHNAME_INCLUDES_EMPLOYEE ? 'team' : 'customer');
  const loginEnv = Boolean(process.env.ENABLE_EMPLOYEE_PASSWORD_LOGIN);

  useEffect(() => {
    if (IS_PATHNAME_INCLUDES_EMPLOYEE) {
      window.localStorage.setItem('userType', 'employee');
    } else {
      window.localStorage.setItem('userType', 'customer');
    }
  }, [IS_PATHNAME_INCLUDES_EMPLOYEE, history.location.pathname]);

  const HOST_NAME = process.env.HOST_NAME || '';

  const tabs = [
    {
      id: 'team',
      label: 'TEAM',
    },
    {
      id: 'customer',
      label: 'CUSTOMER',
    },
  ];

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== loginTab) {
        setLoginTab(tabClicked);
      }
      const forgotPasswordItem = document.querySelector('#login-page__forgot-password');
      const loginFormWrap = document.querySelector('.login-page__wrap');
      if (tabClicked === 'team' && forgotPasswordItem && !loginEnv) {
        forgotPasswordItem.style.display = 'none';
      }

      if (tabClicked === 'customer') {
        history.push('/login/customer/');
        loginFormWrap.classList.remove('team-form');
        loginFormWrap.classList.add('customer-form');
        window.localStorage.setItem('userType', 'customer');
      } else {
        history.push('/login/employee/');
        loginFormWrap.classList.remove('customer-form');
        loginFormWrap.classList.add('team-form');
        window.localStorage.setItem('userType', 'employee');
      }
    },
    [history, loginEnv, loginTab]
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className="form__navigation">
        <h2 className="form__heading">Login</h2>
        <TabNav tabs={tabs} onTabClick={handleTabClick} activeTabId={loginTab} />
      </div>
      {loginTab === 'customer' ? (
        <>
          <Input
            label="Business Email"
            helper={(touched.username && reducedErrors.username) || ''}
            helperVariant={touched.username && reducedErrors.username ? 'error' : 'message'}
            fieldProps={{
              name: 'username',
              value: username,
              placeholder: 'Enter your business email or username',
              onChange: handleChange('username'),
              onBlur: handleBlur('username'),
            }}
          />
          <Input
            label="Password"
            helper={(touched.password && reducedErrors.password) || ''}
            helperVariant={touched.password && reducedErrors.password ? 'error' : 'message'}
            icon={
              <Icon
                name={passwordVisibility ? 'icon-visibility' : 'icon-invisible'}
                onClick={(e) => setPasswordVisibility(!passwordVisibility)}
              />
            }
            fieldProps={{
              name: 'password',
              value: password,
              type: passwordVisibility ? 'text' : 'password',
              onChange: handleChange('password'),
              onBlur: handleBlur('password'),
            }}
          />
          <Button dataTestId={'submit_customer'} text="Login" type="submit" className="button-login" size="block" />
        </>
      ) : (
        <>
          {loginEnv && (
            <>
              <Input
                label="Work Email"
                helper={(touched.username && reducedErrors.username) || ''}
                helperVariant={touched.username && reducedErrors.username ? 'error' : 'message'}
                fieldProps={{
                  name: 'username',
                  value: username,
                  placeholder: 'Enter your work email or username',
                  onChange: handleChange('username'),
                  onBlur: handleBlur('username'),
                }}
              />
              <Input
                label="Password"
                helper={(touched.password && reducedErrors.password) || ''}
                helperVariant={touched.password && reducedErrors.password ? 'error' : 'message'}
                icon={
                  <Icon
                    name={passwordVisibility ? 'icon-visibility' : 'icon-invisible'}
                    onClick={(e) => setPasswordVisibility(!passwordVisibility)}
                  />
                }
                fieldProps={{
                  name: 'password',
                  value: password,
                  type: passwordVisibility ? 'text' : 'password',
                  onChange: handleChange('password'),
                  onBlur: handleBlur('password'),
                }}
              />
              <Button dataTestId={'submit_employee'} text="Login" type="submit" className="button-login" size="block" />
            </>
          )}
          <div className="form__google-login">
            <a href={`${HOST_NAME}/google_login`} className={'button button_block button_danger'}>
              Login with Google account
            </a>
          </div>
        </>
      )}
    </form>
  );
};

export default LoginPageView;
